import React, { useContext } from 'react';

import { Button, message } from 'antd';
import { CurrentApplicationContext } from '../../ApplicationOverview';
import { showFailure } from 'actions/notificationActions';
import { connect } from 'react-redux';
import { apiPost } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';
import { useMutation } from '@tanstack/react-query';
import { phaseTwoWip } from '../../common/actions/WipModal';
import { useQueryClient } from '@tanstack/react-query';

const InviteAllText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.RemindAll'
);

const RemindApplicantsButton = ({ showFailure }) => {
  const application = useContext(CurrentApplicationContext);
  const queryClient = useQueryClient();

  const remindApplicantsToSubmitMutation = useMutation({
    mutationFn: (application) =>
      apiPost(
        `/landlords/application_management/applications/${application?.id}/applicants/remind_all`
      ),
    onSuccess() {
      message.success(
        getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.RemindAll.success'
        )
      );
      queryClient.invalidateQueries({ queryKey: ['applications'] });
    },
    onError(error) {
      showFailure(error);
    },
  });

  return (
    <Button
      loading={remindApplicantsToSubmitMutation.isLoading}
      key="remind_all"
      type="primary"
      onClick={() => phaseTwoWip(() => remindApplicantsToSubmitMutation.mutate(application))}
    >
      {InviteAllText}
    </Button>
  );
};

export default connect(null, { showFailure })(RemindApplicantsButton);
